import React, { useState } from 'react';
// import { useCopyToClipboard } from 'usehooks-ts';

const formatCartShareLink = (items) => {
  let productIds = [];
  items.forEach((item) => productIds.push(`${item.variant_id}:${item.quantity}`));
  return `${window.location.origin}/cart/${productIds.join(',')}`;
};

const ShareCartLink = (props) => {
  const { data } = props;
  const { items } = data;
  const [copied, setCopied] = useState(false);
  // const [value, copy] = useCopyToClipboard();
  const copyToClipboard = async () => {
    const link = formatCartShareLink(items);
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <div className="share-bag">
      <span>Share this bag:</span>
      <button onClick={copyToClipboard}>{copied ? 'Copied!' : 'Copy Link'}</button>
    </div>
  );
};

export default ShareCartLink;
